/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import { Modal, Button, DatePicker, Divider, Select, message } from 'antd';
import moment from 'moment';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import { DataService } from '../../../config/dataService/dataService';
import { FORM_HIDE_TIMEOUT_SECONDS } from '../../../config/config';

const tLabelClassName = `text-[16px] font-bold text-gray-500 text-wrap`
const tValueClassName = `text-[16px] font-bold text-black text-wrap`

const statusesArray = [
  {
    id: 2,
    label: 'COMPLETED'
  },
  {
    id: 4,
    label: 'FAILED'
  },
]

const { Option } = Select;

const FormDialog = ({ showDialog, courseData = {}, setReload, setReloadParrent }) => {
  const [busy, setBusy] = useState(false);
  const [statusID, setStatusID] = useState(2);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSubmit = async () => {
    try {

      if (!startDate || !endDate) {
        message.error('Please select start and end date both')
        return;
      }

      if (moment(startDate).isAfter(moment(endDate))) {
        message.error('Start date should be before end date')
        return;
      }

      setBusy(true)


      const response = await DataService.post('/emp-training/update-training-trainings', {
        training_id: courseData.id,
        // 2024-12-14 18:24:14

        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        status_id: statusID
      });
      const { status } = response.data;
      if (status) {
        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          setReloadParrent(true)
          setReload(true);
          showDialog(false);
        });
      } else {
        message.error(`Error in submitting request:  ${response.data.message}`)
        setBusy(false)
      }

    } catch (error) {
      message.error(`Error in submitting request:  ${error.message}`)
      setBusy(false)
    }
  }

  return (
    <Modal
      open
      title='Update Training Status'
      cancelText="Cancel"
      width="70%"
      okText="Submit"
      confirmLoading={busy}
      centered
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      onOk={handleSubmit}
      cancelButtonProps={{
        disabled: busy
      }}
      destroyOnClose
    >
      <div className="flex flex-col w-full items-center space-y-2">
        {/* Course Name */}
        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Employee Name:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <span className={tValueClassName}>{courseData.emp_name}</span>
          </div>
        </div>
        <Divider />
        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Employee CNIC:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <span className={tValueClassName}>{courseData.emp_cnic}</span>
          </div>
        </div>
        <Divider />

        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Company Name:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <span className={tValueClassName}>{courseData.comp_name}</span>
          </div>
        </div>
        <Divider />

        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Course Name:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <span className={tValueClassName}>{courseData.course_name}</span>
          </div>
        </div>
        <Divider />

        {/* Center Name */}
        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Center Name:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <span className={tValueClassName}>{courseData.center_name}</span>
          </div>
        </div>
        <Divider />

        {/* Dates */}
        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Started At:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <DatePicker onChange={(value, dataStr) => {
              setStartDate(dataStr)
            }} className="h-10 w-full" disabled={busy} />
          </div>
        </div>

        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Ended At:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <DatePicker onChange={(value, dataStr) => {
              setEndDate(dataStr)
            }} className="h-10 w-full" disabled={busy} />
          </div>
        </div>
        <Divider />
        <div className="w-full flex justify-between items-center">
          <div className="w-1/3 text-center">
            <span className={tLabelClassName}>Training Status:</span>
          </div>
          <div className="w-2/3 text-left mr-5">
            <Select
              placeholder="Select a zone"
              optionFilterProp="children"
              value={statusID}
              disabled={busy}
              className='w-full'
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={value => setStatusID(value)}
            >
              {statusesArray.map(item => <Option value={item.id}>{item.label}</Option>)}
            </Select>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default FormDialog;
